import React from "react";
// import image from '../../Assets/footerbg.png'
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestSquare,
  FaYoutubeSquare,
} from "react-icons/fa";
import { FaTwitter } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/logo/logo.svg";
import Location from "../../Assets/Footer/Location.png";
import Email from '../../Assets/Footer/email.png'
import Call from '../../Assets/Footer/Call.png'

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <footer
        className="footer-bg bg-cover bg-center"
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="px-4 py-10  bg-[#FFEFEA]">
          <div className="grid md:grid-cols-[1.5fr_2fr_1fr] lg:grid-cols-[1fr_2fr_1fr] grid-cols-1 gap-10 w-[90%] mx-auto ">
            <div className="md:mt-4">
              <h2 className="text-lg font-bold mb-4 text-[#4E2728]">
                QUICK LINKS
              </h2>
              <ul className="text-[#C2775B]">
                <li
                  onClick={() => {
                    navigate("/");
                    window.scrollTo(600, 0);
                  }}
                  className="mb-2 flex items-center cursor-pointer"
                >
                  Home
                </li>
                <li
                  onClick={() => {
                    navigate("/about");
                    window.scrollTo(600, 0);
                  }}
                  className="mb-2 flex items-center cursor-pointer"
                >
                  About Us
                </li>
                <li
                  onClick={() => {
                    navigate("/services");
                    window.scrollTo(600, 0);
                  }}
                  className="mb-2 flex items-center cursor-pointer"
                >
                  Services
                </li>
                <li
                  onClick={() => {
                    navigate("/offers");
                    window.scrollTo(600, 0);
                  }}
                  className="mb-2 flex items-center cursor-pointer"
                >
                  Offers
                </li>
                <li
                  onClick={() => {
                    navigate("/contact");
                    window.scrollTo(600, 0);
                  }}
                  className="mb-2 flex items-center cursor-pointer"
                >
                  Contact
                </li>
              </ul>
            </div>
            <div className="text-center lg:mr-12 text-[#C2775B] flex flex-col md:items-center">
              <img src={logo} alt="logo" className="md:w-24 lg:w-36" />
              <p className="mb-4 text-start md:text-center mt-4 w-full">
                Passionate Experts Ready to Serve You: Uniting Skill,
                Dedication, and Innovation for Your Ultimate Satisfaction.
              </p>
              <div className="flex justify-center space-x-4 text-[#4E2728]">
                <div>
                  <a
                    href="https://www.facebook.com/p/Kaira-Salon-61555288714974/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.instagram.com/kaira.salon/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </div>
                <FaTwitter />

                <FaYoutubeSquare />
                <FaPinterestSquare />
              </div>
            </div>
            <div className="md:mt-4">
              <h2 className="text-lg font-bold mb-4 text-[#4E2728]">
                CONTACT US
              </h2>
              <div className="flex items-center gap-4">
                <img src={Location} alt="" className="h-4" />
                <p className="mb-2 text-[#C2775B]">
                  Fast floor, Plot no - 2726/2727, Beheramal, near Domino’s
                  pizza, Jharsuguda, Odisha
                </p>
              </div>
              <div className="flex items-center gap-4">
                <img src={Email} alt="" className="h-4"/>
                <p className="mb-2 text-[#C2775B]">
                  kairasaloon@gmail.com
                </p>
              </div>
              <div className="flex items-center gap-4">
                <img src={Call} alt="" className="h-4"/>
              <p className="mb-2 text-[#C2775B]">
                 +91-9777172793
              </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="py-4 bg-[#4B0011] text-[#F1F1F1]">
        <div className="md:mx-16 px-4 flex flex-wrap justify-between items-center">
          <p className="w-full sm:w-auto text-center sm:text-left">
            © {currentYear} KAYA SPA All Rights Reserved.
          </p>
          <p className="w-full sm:w-auto text-center sm:text-right">
            Design & Developed by{" "}
            <a
              href="https://www.webbocket.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              WEB_BOCKET
            </a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
